<ng-container *ngIf="fieldSubmission.field.options.view">
  <div class="form-item" [ngClass]="'form-field-'+fieldSubmission.field.type">
    <div class="form-content">
      <div>
        <core-helpers-forms-button [disabled]="link == ''" [text]="fieldSubmission.field.label" (submit)="goToUrl()">
        </core-helpers-forms-button>
      </div>
    </div>
  </div>
</ng-container>